import { Controller } from "stimulus"
import  axios  from 'axios'
export default class extends Controller {
  static get targets() {
    return ['dragItem'];
  }
 
  dragstart(e) {
    e.dataTransfer.setData('application/drag-key', e.target.getAttribute("data-row-id") ) 
    e.dataTransfer.effectAllowed = "move"

  }

  dragover(e) {
    e.preventDefault()
    return true
  }

  dragenter(e) {
    e.preventDefault()

  }

  drop(e){
    var data = e.dataTransfer.getData("application/drag-key")
    const dropTarget = e.target.closest('tr')
    const draggedItem = this.element.querySelector(`[data-row-id='${data}']`);
    const positionComparison = dropTarget.compareDocumentPosition(draggedItem)
    if ( positionComparison & 4) {
       dropTarget.insertAdjacentElement('beforebegin', draggedItem);
    } else if ( positionComparison & 2) {
        dropTarget.insertAdjacentElement('afterend', draggedItem);
    }
    e.preventDefault()
  }

  dragend(e){
    let t = this; 
    var orderMapping = {}
    var payload = {};
       
    this.dragItemTargets.forEach(function(v, i) {
      orderMapping[v.getAttribute('data-row-id')] = i; 

    })
    
    payload[this.data.get('object-name')] = orderMapping; 

    axios.defaults.headers.common['Accept'] = 'application/json';
    axios.put(this.data.get('endpoint'), payload)
        .then(function(response){
          console.log('element reordered'); 

        }).catch(function(err){

        })
  }
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/item_drag_controller.js